import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { ReportType } from '../../core/api/clients';
import { useAppData } from '../../core/context/AppDataContext';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';
import FlightOperationNotificationHome from './FlightOperationNotificationHome';
import FlightOperationNotificationFormEdit from './FlightOperationNotificationEdit';
import FlightOperationNotificationLayout from './FlightOperationNotificationLayout';
import FlightOperationNotificationNew from './FlightOperationNotificationNew';
import FlightOperationNotificationView from './FlightOperationNotificationView';
import useTitle from '../../core/api/hooks/common/useTitle';

function FlightOperationNotificationContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.FlightOperationNotification);

    if (form !== undefined) {
      const { isContributor, isAdministrator, isReader, isApprover } = form;
      const canEdit = (isContributor || isApprover || isAdministrator);
      const canView = (isReader || canEdit);
      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<FlightOperationNotificationLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={canEdit ?? false}>
                    <FlightOperationNotificationFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth
                    isAuthorized={canView ?? false}
                  >
                    <FlightOperationNotificationView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              path="new"
              element={(
                <RequireAuth isAuthorized={form.isContributor ?? false}>
                  <FlightOperationNotificationNew />
                </RequireAuth>
              )}
            />
            <Route
              index
              element={(
                <FlightOperationNotificationHome />
              )}
            />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return (
      <span>Not Authorized</span>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default FlightOperationNotificationContainer;
